class BaseError {
  status = 0;
  message = "";
  constructor(state) {
    Object.assign(this, { ...state });
  }
}
class ApplicationError extends BaseError {}
class AccessError extends BaseError {}
class BadRequest extends BaseError {}
class NotFound extends BaseError {}

function throwBackendError(error) {
  if (!error.response) {
    return;
  }
  console.log(error);
  const currentError = {
    status: error.response.status,
    message: error.response.data,
  };
  switch (error.response.status) {
    case 500:
      throw new ApplicationError(currentError);
    case 403:
      throw new AccessError(currentError);
    case 400:
      throw new BadRequest(currentError);
    case 404:
      throw new NotFound(currentError);
    default:
      return;
  }
}

export { throwBackendError };
